/**
 * Page Performance — control hooks for code outside the tracker (pure, no
 * React/DOM imports).
 *
 * The mounted `PagePerfTracker` registers its engine here; the auth store
 * calls in at the two moments the identity behind the tab changes:
 *
 *   - `flushPagePerf()` — immediately BEFORE the account-switch POST: the
 *     open in progress is reported (abandoned) and everything queued is sent
 *     while the cookie still belongs to the person who measured it. Nothing
 *     more is queued until the next route change, so the reload that follows
 *     the switch cannot report this page under the new account.
 *   - `clearPagePerf()` — on a stale tab (another tab changed the identity):
 *     the cookie already belongs to someone else, so the open in progress and
 *     everything queued are discarded, not sent.
 *
 * Both are no-ops when no tracker is mounted, and never throw.
 */

let engine = null

/** Register the mounted engine; returns the unregister function. */
export function registerPagePerf(next) {
  engine = next || null
  return () => {
    if (engine === next) engine = null
  }
}

export function flushPagePerf() {
  try {
    engine?.flushNow?.()
  } catch {
    /* never throw from the tracker */
  }
}

export function clearPagePerf() {
  try {
    engine?.clearAll?.()
  } catch {
    /* never throw from the tracker */
  }
}
